import useNonInitialRenderHook from 'src/common/hooks/useNonInitialRenderHook';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { useMsal } from '@azure/msal-react';
import { logout as logoutHybrisAPI } from 'src/common/redux/actions';
import { resetCalendarFilters as resetCalendarFiltersAction } from 'src/pages/home/redux/actions';
import { logoutSSO } from 'src/common/redux/actions/index';
import { clearPersistStorage, clearStorageBrowserClose } from 'src/utils/util';

const LogoutActions = ({ logoutRquested, setlogoutPopUp }) => {
    const dispatch = useDispatch();
    const { instance } = useMsal();

    // All Redux data
    const displayFilters = useSelector(
        (state) => state.appliedFiltersReducer.displayFilters,
        shallowEqual
    );

    const defaultCalendarView = useSelector(
        (state) => state.appliedFiltersReducer.defaultCalendarView,
        shallowEqual
    );
    const networkId = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.networkId
    );

    const resettingFilters = useSelector(
        (state) => state.setfilterOptionsReducer.resettingFilters
    );

    const resettingFiltersSuccess = useSelector(
        (state) => state.setfilterOptionsReducer.resettingFiltersSuccess
    );
    const orderCondition = useSelector(
        (state) => state.appliedFiltersReducer.displayOrderCondition
    );

    // All effects
    useNonInitialRenderHook(() => {
        if (logoutRquested) {
            if (setlogoutPopUp) setlogoutPopUp(false);

            // Do all the cleanup
            if (displayFilters.length || !orderCondition) {
                resetCalendarFilters();
            }

            // More conditionas can eb added here
            if (!displayFilters.length && orderCondition) {
                logoutWithCleanUp();
            }
        }
    }, [logoutRquested]);

    useNonInitialRenderHook(() => {
        if (!resettingFilters && resettingFiltersSuccess) {
            logoutWithCleanUp();
        }
    }, [resettingFilters, resettingFiltersSuccess]);

    // Reset all the calendar filters
    const resetCalendarFilters = () => {
        dispatch(
            resetCalendarFiltersAction({
                fields: 'DEFAULT',
                calendarSelection: defaultCalendarView.id,
                filteredAccounts: '',
                filteredOrderStatuses: '',
                filteredPhysicians: '',
                filteredProcedures: '',
                assignedFlag: true,
            })
        );
    };

    // Clean up local data event handler, local storage, session storage
    const logoutWithCleanUp = () => {
        const isCompactScreen = localStorage.getItem(
            `isCompactScreen_${networkId}`
        );
        localStorage.removeItem('authToken');
        localStorage.removeItem('lastSelDLPCalView');
        localStorage.removeItem('userAuthenticated');
        sessionStorage.removeItem('employeeRole');
        sessionStorage.removeItem('isCondensedViewState');
        localStorage.clear();
        sessionStorage.clear();
        if (isCompactScreen !== null) {
            localStorage.setItem(
                `isCompactScreen_${networkId}`,
                isCompactScreen
            );
        }

        window.onbeforeunload = null;
        // Logout depending SSO is enabled or disabled
        // eslint-disable-next-line no-undef

        // eslint-disable-next-line no-undef
        if (process.env.ENABLE_SSO) {
            dispatch(logoutSSO(true));

             instance.logoutRedirect({
                // eslint-disable-next-line no-undef
                postLogoutRedirectUri: process.env.LOGOUT_URI, // Optional, can be customized
            });
        }else {
            dispatch(logoutHybrisAPI());
        }
        clearStorageBrowserClose(dispatch);
        clearPersistStorage();
        // window.location.pathname = '/login';
    };

    return '';
};

export default LogoutActions;
